export default __webpack_public_path__ + "static/media/support-org3.99ee0ee2.png";